let mapTimeout;
export function resetMapTimeout() {
    window.clearTimeout(mapTimeout);
}
export function rememberMapTimeout(timeout) {
    mapTimeout = timeout;
}
